<ul class="MyMoeinList">

  <li *ngFor="let item of DataList_Peyvast">

    <div *ngIf="canOpenPeyvast">
        <a target="_blank" *ngIf="item.letterType=='رسید امانت'"
        [routerLink]="['/LetterRequestCustomerPreOrder',{id:item.id}]"><i class="fa fa-file"></i> نامه شماره <b>{{item.code}}</b> ({{item.letterType}}) </a>
      <a target="_blank" *ngIf="item.letterType=='نامه وارده'"
        [routerLink]="['/LetterRequestCustomerDraftForm',{id:item.id}]"><i class="fa fa-file"></i> نامه شماره <b>{{item.code}}</b> ({{item.letterType}}) </a>
      <a target="_blank" *ngIf="item.letterType=='نامه صادره'"
        [routerLink]="['/LetterRequestCustomerForm',{id:item.id}]"><i class="fa fa-file"></i> نامه شماره <b>{{item.code}}</b> ({{item.letterType}}) </a>
      <a target="_blank" *ngIf="item.letterType=='درخواست کالیبراسیون'"
        [routerLink]="['/LetterRequestCustomerCalibration',{id:item.id}]"><i class="fa fa-file"></i> نامه شماره <b>{{item.code}}</b> ({{item.letterType}}) </a>

    </div>
    <div  *ngIf="!canOpenPeyvast">
        <a  *ngIf="item.letterType=='رسید امانت'"  ><i class="fa fa-file"></i> نامه شماره <b>{{item.code}}</b> ({{item.letterType}}) </a>
        <a  *ngIf="item.letterType=='نامه وارده'"><i class="fa fa-file"></i> نامه شماره <b>{{item.code}}</b> ({{item.letterType}}) </a>
        <a  *ngIf="item.letterType=='نامه صادره'"><i class="fa fa-file"></i> نامه شماره <b>{{item.code}}</b> ({{item.letterType}}) </a>
        <a  *ngIf="item.letterType=='درخواست کالیبراسیون'"><i class="fa fa-file"></i> نامه شماره <b>{{item.code}}</b> ({{item.letterType}}) </a>

    </div>

    <div class="subMoeinDiv">

      <div *ngIf="item.letterType!='رسید امانت'">
        <div class="subMoeinDivDetail">
          <p> آخرین کاربر فرستنده : {{item.lastSender}} </p>
          <p> آخرین کاربر گیرنده : {{item.lastGiver}} </p>
          <p> آخرین وضیعت: {{item.lastSection}} </p>
          <p> آخرین پیام: {{item.lastOrder}} </p>
          <p> {{item.persianDate}} </p>
        </div>
        <div style="clear:both"></div>
        <p class="subMoeinDsc"> موضوع نامه : {{item.subject_name}} </p>
        <p class="subMoeinDsc"> نام گیرنده : {{item.giver_name}} </p>
        <p class="subMoeinDsc"> سمت گیرنده : {{item.giver_semat}} </p>
        <p class="subMoeinFooter">{{item.persianDate}}</p>
      </div>
      <div *ngIf="item.letterType=='رسید امانت'">
        <div class="subMoeinDivDetail">
          <p> ثبت کننده : {{item.lastSender}} </p>
          <p> وضیعت: {{item.lastSection}} </p>
          <p> پیام: {{item.lastOrder}} </p>
          <p> {{item.persianDate}} </p>
        </div>
        <div style="clear:both"></div>
      </div>


      <a target="_blank" *ngIf="item.letterType=='رسید امانت'"
        [routerLink]="['/LetterRequestCustomerPreOrder',{id:item.id}]"><i class="fa fa-eye"></i> مشاهده </a>
      <a target="_blank" *ngIf="item.letterType=='نامه وارده'"
        [routerLink]="['/LetterRequestCustomerDraftForm',{id:item.id}]"><i class="fa fa-eye"></i> مشاهده </a>
      <a target="_blank" *ngIf="item.letterType=='نامه صادره'"
        [routerLink]="['/LetterRequestCustomerForm',{id:item.id}]"><i class="fa fa-eye"></i> مشاهده </a>
      <a target="_blank" *ngIf="item.letterType=='درخواست کالیبراسیون'"
        [routerLink]="['/LetterRequestCustomerCalibration',{id:item.id}]"><i class="fa fa-eye"></i> مشاهده </a>

    </div>
    <app-LetterRequestCustomerPeyvast [canOpenPeyvast]="canOpenPeyvast" [DataList_Peyvast]="item.detail"></app-LetterRequestCustomerPeyvast>
  </li>
</ul>
